<template>
  <!-- New Main Navigation -->
  <!-- 
    :class="{
      'collapsed-left': isMenuCollapsed,
      'collapsed-right': isDetailCollapsed,
    }" 
  -->
  <div class="container-fluid ps-0 modal-chat-inbox">
    <div class="row">
      <div ref="mainNavEl" class="p-0 d-flex flex-column justify-content-between bg-gray-dark text-center app-main-nav"
        :class="[{ 'top-45-menu': isAlertOn, 'nav-expanded': isNavExpanded }]"
        @mouseleave="scheduleCollapseNav">
        <div class="nav-scroll-area"
          @mouseenter="expandNav" @mouseleave="scheduleCollapseNav">
          <div class="list-group nav-icons nav-icons-scroll">
            <!-- brand logo -->
            <div class="position-relative">
              <a href="javascript:void(0)"
                class="list-group-item list-group-item-action bg-transparent py-2 border-0 p-0 brand-logo-inbox-chat"
                data-bs-toggle="tooltip" @mouseleave="$store.commit('removeToolTip')" data-bs-placement="right" title=""
                data-bs-trigger="hover"
                @click="$router.push({ name: $store.state.agent_role === 'agent' ? 'ChatInboxClone' : 'Content' }) && toggleMenuCollapse()">
                <svg viewBox="0 0 513 421" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="text-lg">
                  <path id="SymbolLogo"
                    d="M486.367 5.66518C470.401 -2.0562 451.334 -0.0486403 437.383 10.7613L256.331 151.754L74.9685 10.298C60.8626 -0.357495 41.9513 -2.0562 26.1402 5.66518C10.4841 13.541 0.408447 29.6015 0.408447 47.2062V373.821C0.408447 391.58 10.4841 407.64 26.6052 415.516C33.1157 418.605 40.0912 420.149 46.9116 420.149C57.1423 420.149 67.218 416.752 75.5886 410.266L220.058 301.703C208.123 291.511 168.905 260.471 141.623 238.697L98.0651 274.06V149.746L175.88 210.9L254.781 275.605L255.091 275.296L437.228 410.266C451.179 421.23 470.246 423.238 486.212 415.516C502.178 407.795 512.408 391.58 512.408 373.821V47.2062C512.408 29.447 502.333 13.3866 486.367 5.66518ZM414.752 276.995L336.781 213.37L414.752 149.901V276.995Z"
                    fill="currentColor" />
                </svg>
              </a>
            </div>

            <template v-if="$store.state.isPermissionsFetched">
              <template v-for="(group, gi) in navGroups" :key="'g' + gi">
                <template v-for="item in group.items" :key="item.key">
                  <div v-if="item.visible" :id="item.id || undefined" :class="item.navClass"
                    data-bs-toggle="tooltip" @mouseleave="$store.commit('removeToolTip')"
                    data-bs-placement="right" data-bs-trigger="hover"
                    :title="isNavExpanded ? '' : item.tooltip" @click="handleRouterLinkClick">
                    <router-link :to="item.route" @mouseleave="removeToolTip()"
                      class="list-group-item list-group-item-action bg-transparent py-2 border-0"
                      :class="[darkModes, item.activeClass]">
                      <i :class="[item.icon, 'text-sm']"></i>
                      <span v-if="item.key === 'inbox' && inboxBadgeCount > 0"
                        class="plus unread-conversations"
                        :class="{ 'hundred-plus': inboxBadgeCount > 99 }">
                        {{ inboxBadgeCount }}
                      </span>
                    </router-link>
                  </div>
                </template>
              </template>
            </template>
          </div>
        </div>
        <!-- The last 3 icon links that should stay at the bottom -->
        <div class="mt-auto list-group nav-icons">
          <!-- <a v-if="user_type !== 'agent'" href="javascript:void(0)" class="list-group-item list-group-item-action bg-transparent py-2 border-0" data-bs-toggle="tooltip" @mouseleave="$store.commit('removeToolTip')" data-bs-placement="right" data-bs-trigger="hover" title="Help" @click="showAhw = !showAhw">
            <div id="admin-help-widget" class="admin-help-widget positon-absolute bottom right">
              <i v-if="!showAhw" class="fa-solid fa-circle-question fa-2x"></i>
              <i v-else class="fa-sharp fa-solid fa-circle-chevron-up fa-2x"></i>
            </div>
          </a> -->
          <!-- <a v-if="user_type !== 'agent'" href="javascript:void(0)" class="list-group-item list-group-item-action bg-transparent py-2 border-0" data-bs-toggle="tooltip" @mouseleave="$store.commit('removeToolTip')" data-bs-placement="right" data-bs-trigger="hover" title="Preview SOP" @click="showSop = !showSop">
            <i class="fa-regular fa-clipboard-list-check fa-2x"></i>
          </a>
          <a v-if="user_type !== 'agent'" href="javascript:void(0)" class="list-group-item list-group-item-action bg-transparent py-2 border-0" data-bs-toggle="tooltip" @mouseleave="$store.commit('removeToolTip')" data-bs-placement="right" data-bs-trigger="hover" title="Preview" @click="showWidget = !showWidget">
            <i class="fa-solid fa-eye text-sm"></i>
          </a> -->

          <!-- <div data-bs-toggle="tooltip" data-bs-placement="right" data-bs-trigger="hover" title="Activities"
            class="py-2">
            <button type="button" class="list-group-item list-group-item-action bg-transparent py-2 border-0"
              @mouseleave="removeToolTip()" data-bs-toggle="modal" data-bs-target="#activitiesModal">
              <i class="fa-solid fa-bell text-lg"></i>
              <span class="plus unread-conversations userfeednotifications" v-if="totalUnreadActivityFeeds > 0">
                {{ totalUnreadActivityFeeds > 99 ? '99+' : totalUnreadActivityFeeds }}
              </span>
            </button>
          </div> -->

          <!-- <a href="javascript:void(0)" class="list-group-item list-group-item-action bg-transparent py-2 border-0" data-bs-toggle="tooltip" @mouseleave="$store.commit('removeToolTip')" data-bs-placement="right" data-bs-trigger="hover" title="Sign Out" @click="logout_user">
            <i class="fa-solid fa-right-from-bracket text-sm"></i>
          </a> -->
          <!-- Quick colour picker, switched on in Settings → Theme -->
          <div v-if="isModalAdminThemeShortcutActive" ref="colorMenuEl" class="position-relative admin-theme-quick"
            @mouseenter="openColorMenu()" @mouseleave="scheduleColorMenuClose()" @focusin="isColorMenuPinned = true"
            @keydown.esc="closeColorMenu()">
            <Popper placement="right-end" offset-distance="6" :show="isColorMenuOpen">
              <button type="button" aria-label="Admin colors"
                class="list-group-item list-group-item-action bg-transparent py-2 border-0 admin-theme-quick-btn"
                :class="{ active: isColorMenuOpen }">
                <i class="fa-solid fa-palette text-sm"></i>
              </button>

              <template #content>
                <div class="popover-content bg-white admin-theme-quick-panel">
                  <div class="d-flex align-items-center justify-content-between px-2 py-2 border-bottom border-light">
                    <span class="text-sm fw-bold text-dark">Admin Colors</span>
                    <button type="button" class="btn btn-light btn-sm p-0 mb-0 text-xs shadow-none text-dark p-2"
                      @click="resetModalAdminTheme()">
                      Reset
                    </button>
                  </div>

                  <div class="px-2 pt-2 pb-1 border-bottom border-light admin-theme-presets ">
                    <div class="text-xs fw-semibold text-muted mt-1 mb-2" style="font-size: 0.6rem; letter-spacing: 0.04em;">Quick Presets</div>
                    <div class="admin-theme-presets-grid mb-2">
                      <button v-for="preset in modalAdminThemePresets" :key="preset.id"
                        type="button" class="admin-theme-preset-btn"
                        :class="{ 'admin-theme-preset-btn--active': activePresetId === preset.id }"
                        :title="preset.name"
                        @click="applyPreset(preset)">
                        <span class="admin-theme-preset-dot" :style="{ background: preset.colors.canvasBg }"></span>
                        <span class="text-truncate">{{ preset.name }}</span>
                      </button>
                    </div>
                  </div>

                  <div class="px-2 pt-2 admin-theme-quick-fields">
                    <template v-for="group in modalAdminThemeFieldGroups" :key="group.name || 'general'">
                      <div v-if="group.name" class="admin-theme-quick-group">{{ group.name }}</div>
                      <div v-for="field in group.fields" :key="field.key"
                        class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-xs text-dark me-2 text-truncate admin-theme-quick-label">
                          {{ field.short }}
                        </span>
                        <div class="d-flex align-items-center border rounded p-1 admin-theme-quick-input">
                          <input type="color" class="border-0 p-0" :aria-label="field.label"
                            v-model="modalAdminTheme[field.key]" />
                          <input class="form-control border-0 p-0 ps-2 text-xs shadow-none" :aria-label="field.label"
                            v-model="modalAdminTheme[field.key]" />
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="px-2 pb-3 pt-1 text-start">
                    <button type="button" class="btn btn-success btn-sm mb-0 py-1 px-2 text-xs text-white"
                      :disabled="!isModalAdminThemeDirty || isSavingModalAdminTheme" @click="saveQuickAdminTheme()">
                      {{ isSavingModalAdminTheme ? 'Saving...' : 'Save changes' }}
                    </button>
                  </div>
                </div>
              </template>
            </Popper>
          </div>

          <!-- data-bs-toggle="tooltip" @mouseleave="$store.commit('removeToolTip')" data-bs-placement="right" data-bs-trigger="hover" title=""  -->
          <!-- @click="handleRouterLinkClick" -->
          <div class="position-relative profile-details-wrap">
            <Popper v-bind="$attrs" hover>
              <router-link :to="{ name: 'Account' }" @mouseleave="removeToolTip()"
                class="list-group-item list-group-item-action bg-transparent py-2 border-0 mb-2 profile-icon">
                <div class="profile-image-container">
                  <img v-if="$store.state.agent_picture" :src="$store.state.agent_picture"
                    alt="" class="profile-image" style="object-fit: cover" />
                  <!-- <i v-else class="text-lg fa-solid fa-circle-user fa-2x"></i> -->
                  <i v-else class="fa-duotone fa-circle-user fa-2x text-lg profile-default-ico"> </i>
                </div>

                <div class="fa-2x me-2 profile-default-ico profile-default-ico-nav"><span class="online-status"
                    :class="{ 'offline-status': awayMode }"></span></div>
              </router-link>

              <!-- <router-link :to="{ name: 'Account' }" class="list-group-item list-group-item-action bg-transparent py-2 border-0 mb-2 profile-icon">
              <i class="text-lg fa-solid fa-circle-user text-lg shadow rounded"></i>
              <img v-if="$store.state.agent_picture" :src="$store.state.agent_picture" alt="">
              <i v-else class="text-lg fa-solid fa-circle-user fa-2x"></i>
              <div class="cursor-pointer">
                    <img  :src="require('@/assets/img/userprofile-new.jpg')" class="rounded-1" alt="user">
                </div>
            </router-link> -->

              <template #content="{ close }">
                <div class="popover-content bg-white rounded-3 shadow inbox-nav-manage-options">
                  <div class="col-12 container-fluid p-0">
                    <div class="profile-details">
                      <div class="card rounded-3 border p-0">
                        <ul class="list-unstyled text-sm">
                          <div class="card-header p-2 border-bottom border-light">
                            <li class="py-1 d-flex align-items-center justify-content-start"
                              :class="{ active: $route.name === 'Account' }">
                              <div class="d-flex align-items-center position-relative">
                                <div class="profile-image-container">
                                  <img v-if="$store.state.agent_picture"
                                    :src="$store.state.agent_picture" alt=""
                                    class="profile-image" style="object-fit: cover" />
                                  <i v-else class="fa-duotone fa-circle-user fa-2x profile-default-ico"> </i>
                                </div>
                                <!-- <i class="fa-duotone fa-circle-user fa-2x me-2 profile-default-ico"> <span 
                                  class="online-status" :class="{ 'offline-status': awayMode }"></span></i> -->
                                <div class="fa-2x me-2 profile-default-ico"><span class="online-status"
                                    :class="{ 'offline-status': awayMode }"></span></div>
                              </div>
                              <div class="text-start" style="word-break: break-word;"
                                :class="[$store.state.agent_picture ? 'mx-1' : 'mx-2']">
                                <div>{{ $store.state.agent_name || 'Agent' }}</div>
                                <div class="text-xs"
                                  style="white-space: nowrap; width: 150px; overflow: hidden; text-overflow: ellipsis">
                                  {{ user_email }}
                                </div>
                              </div>
                            </li>
                            <li class="py-1 d-flex align-items-center justify-content-between"
                              :class="{ active: $route.name === 'Account' }">
                              <div class="d-flex align-items-center">Away mode</div>
                              <div class="d-flex align-items-center p-0">
                                <div class="form-check form-switch">
                                  <input class="form-check-input m-0" type="checkbox"
                                    :checked="$store.state.is_away == 1" @change="changeStatus($event)" />
                                </div>
                              </div>
                            </li>
                          </div>
                          <div class="p-2 py-1 border-bottom border-light position-relative">
                            <li class="theme-dark-light d-flex align-items-center justify-content-between">
                              <div class="d-flex align-items-center">
                                Theme
                                <div class="d-flex align-items-center justify-content-start mx-0" v-if="darkTheme">
                                  <span class="d-flex align-items-center justify-content-start me-2"><i
                                      class="fa-solid fa-moon-stars p-1 mx-2"></i></span>
                                </div>
                                <div class="d-flex align-items-center justify-content-start mx-0" v-else>
                                  <span class="d-flex align-items-center justify-content-start"><i
                                      class="fa-solid fa-sun-bright p-1 mx-2"></i></span>
                                </div>
                              </div>
                              <div class="d-flex align-items-center">
                                <div class="form-check form-switch theme-switch"><input class="form-check-input m-0"
                                    type="checkbox" v-model="darkTheme" @change="toggleModalTheme" /></div>
                              </div>
                            </li>
                            <li class="d-flex align-items-center justify-content-between py-1"
                              v-if="$store.getters.isDemoModeAvailable">
                              <div class="d-flex align-items-center">
                                Include Demo
                              </div>
                              <div class="d-flex align-items-center">
                                <div class="form-check form-switch">
                                  <input class="form-check-input m-0" type="checkbox"
                                    :checked="$store.getters.isDemoMode" @change="updateDemoMode" />
                                </div>
                              </div>
                            </li>
                          </div>
                          <!-- <div class="p-2  border-bottom border-light position-relative" @click="close">
                            <li class="sub-menu-language py-1  d-flex align-items-center justify-content-between cursor-pointer text-sm">
                              <div class="d-flex align-items-center">
                                <span><strong>Language</strong>: English (US)</span>
                              </div>
                              <div class="d-flex align-items-center">
                              <span><i class="fa-regular fa-chevron-right" style="font-weight: 800; font-size: 11px;"></i></span>
                              </div>
                                <div class="p-3 py-0 profile-details-language d-none">
                                  <div class="card rounded-3 border p-0">
                                    <ul class="list-unstyled text-sm pb-0" style="margin-bottom: 0.5rem !important;">
                                      <div class="card-header p-2">
                                        <li class="py-1  d-flex align-items-center justify-content-between cursor-pointer" @click="close">
                                          <div class="d-flex align-items-center">
                                            <span class="text-sm"><strong>English (US)</strong> </span>
                                          </div>
                                          <div class="d-flex align-items-center">
                                          <span><i class="fa-solid fa-check text-success"></i></span>
                                          </div>
                                        </li>
                                        <li class="py-1  d-flex align-items-center justify-content-between cursor-pointer" @click="close">
                                          <div class="d-flex align-items-center">
                                            <span>Deutsch (DE) </span>
                                          </div>
                                          <div class="d-flex align-items-center">
                                          </div>
                                        </li>   
                                        <li class="py-1  d-flex align-items-center justify-content-between cursor-pointer" @click="close">
                                          <div class="d-flex align-items-center">
                                            <span>Spanish (ES) </span>
                                          </div>
                                          <div class="d-flex align-items-center">
                                          </div>
                                        </li>   
                                      </div>
                                    </ul>
                                  </div>                  
                                </div>                            
                            </li>
                                                
                          </div> -->
                          <div class="card-body border-bottom border-light p-0 py-2" @click="handleRouterLinkClick">
                            <div class="" @click="close">
                              <li
                                class="sub-menu-language py-1 d-flex align-items-center justify-content-between cursor-pointer text-sm"
                                @click="close" v-if="$store.state.userPermissions?.canManageGeneralAndSecuritySettings">
                                <router-link :to="{ name: 'Settings' }"
                                  class="list-group-item list-group-item-action bg-transparent border-0 p-0 text-sm">
                                  <div class="d-flex align-items-center text-sm">
                                    <i class="p-2 py-0 text-sm fa-solid fa-cog me-2"></i>
                                    <span class="text-sm" style="font-size: 0.95em !important">Settings</span>
                                  </div>
                                </router-link>
                              </li>
                            </div>
                            <div class="" @click="close">
                              <li
                                class="sub-menu-language py-1 d-flex align-items-center justify-content-between cursor-pointer">
                                <router-link :to="{ name: 'Account' }"
                                  class="list-group-item list-group-item-action bg-transparent border-0 p-0 mb-0 text-sm">
                                  <div class="d-flex align-items-center text-sm">
                                    <i class="p-2 py-0 text-sm fa-solid fa-user me-2"></i>
                                    <span class="text-sm" style="font-size: 0.95em !important">Your Account</span>
                                  </div>
                                </router-link>
                              </li>
                            </div>
                            <!-- <li class="sub-menu-language py-1  d-flex align-items-center justify-content-between cursor-pointer" @click="close">
                              <div class="d-flex align-items-center">
                                <i class="p-2 py-0 text-sm fa-solid fa-bell-on me-2" style="margin-left: -4px;"></i>
                                Notifications
                              </div>
                            </li> -->
                          </div>
                          <div class="card-footer p-0 m-0 pt-2" @click="logout_user($event);close();">
                            <li
                              class="sub-menu-language py-1 pb-0 m-0 d-flex align-items-center justify-content-between cursor-pointer">
                              <div class="d-flex align-items-center">
                                <i class="p-2 py-0 text-sm fa-solid fa-right-from-bracket me-2"></i>
                                Log Out
                              </div>
                            </li>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </Popper>
          </div>
        </div>

        <!-- Intercom-style floating expand panel -->
        <div class="nav-expand-overlay" :class="{ 'is-open': isNavExpanded }"
          @mouseenter="expandNav" @mouseleave="scheduleCollapseNav">
          <div class="nav-expand-header">
            <svg viewBox="0 0 494 401" fill="none" xmlns="http://www.w3.org/2000/svg" class="nav-expand-logo-svg" style="width:40px;height:40px;">
              <defs>
                <filter id="modalFloodFiller_nav" primitiveUnits="objectBoundingBox">
                  <feFlood flood-color="#4CBB85"></feFlood>
                  <feOffset><animate attributeName="dx" from="-3" to="2" dur="2s" repeatCount="indefinite"></animate></feOffset>
                  <feComposite operator="in" in2="SourceGraphic"></feComposite>
                </filter>
              </defs>
              <g filter="url(#modalFloodFiller_nav)">
                <mask id="pathInside_nav" fill="white">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M94.5 262L137 227.5L212 289L77 388.5C31.5 416 0.499984 390.5 0.499984 341V49.5C-1.00001 3.50002 48 -12.5 79.5 14.5L248 144.5L413.5 15C442 -8.49999 494 -5.50006 494 46V345.5C494 403.5 446 413 402 380.5L94.5 142.5V262ZM319 201.878L410 268V135L319 201.878Z"></path>
                </mask>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M94.5 262L137 227.5L212 289L77 388.5C31.5 416 0.499984 390.5 0.499984 341V49.5C-1.00001 3.50002 48 -12.5 79.5 14.5L248 144.5L413.5 15C442 -8.49999 494 -5.50006 494 46V345.5C494 403.5 446 413 402 380.5L94.5 142.5V262ZM319 201.878L410 268V135L319 201.878Z" fill="#4CBB85"></path>
                <path d="M137 227.5L149.682 212.035L137.064 201.688L124.395 211.972L137 227.5ZM94.5 262H74.5V303.996L107.105 277.528L94.5 262ZM212 289L223.866 305.1L244.568 289.842L224.682 273.535L212 289ZM77 388.5L87.3452 405.617L88.1289 405.143L88.866 404.6L77 388.5ZM0.499981 49.5H20.5V49.174L20.4894 48.8481L0.499981 49.5ZM79.5 14.5L66.4842 29.6851L66.8753 30.0203L67.2831 30.335L79.5 14.5ZM248 144.5L235.783 160.335L248.087 169.827L260.325 160.251L248 144.5ZM413.5 15L425.825 30.7511L426.026 30.5935L426.224 30.4308L413.5 15ZM402 380.5L389.759 396.316L389.936 396.454L390.117 396.587L402 380.5ZM94.5 142.5L106.741 126.684L74.5 101.73V142.5H94.5ZM410 268L398.244 284.18L430 307.254V268H410ZM319 201.878L307.156 185.762L285.103 201.97L307.244 218.058L319 201.878ZM410 135H430V95.4812L398.156 118.884L410 135ZM124.395 211.972L81.895 246.472L107.105 277.528L149.605 243.028L124.395 211.972ZM224.682 273.535L149.682 212.035L124.318 242.965L199.318 304.465L224.682 273.535ZM88.866 404.6L223.866 305.1L200.134 272.9L65.134 372.4L88.866 404.6ZM-19.5 341C-19.5 369.01 -10.7638 395.764 10.4518 410.171C32.8068 425.351 60.8838 421.61 87.3452 405.617L66.6548 371.383C47.6161 382.89 37.4432 380.149 32.9231 377.079C27.2638 373.236 20.5 362.491 20.5 341H-19.5ZM-19.5 49.5V341H20.5V49.5H-19.5ZM92.5158 -0.685183C71.3308 -18.8437 43.3845 -23.1832 20.2222 -13.9545C-3.78612 -4.3887 -20.5076 18.9258 -19.4894 50.1518L20.4894 48.8481C20.0076 34.0742 27.0361 26.3887 35.0278 23.2045C43.8655 19.6832 56.1692 20.8437 66.4842 29.6851L92.5158 -0.685183ZM260.217 128.665L91.7169 -1.33504L67.2831 30.335L235.783 160.335L260.217 128.665ZM401.175 -0.75114L235.675 128.749L260.325 160.251L425.825 30.7511L401.175 -0.75114ZM514 46C514 29.7191 509.851 15.4519 501.48 4.19234C493.088 -7.09504 481.542 -13.8838 469.408 -16.9974C445.934 -23.0211 419.351 -15.7465 400.776 -0.430834L426.224 30.4308C436.149 22.2465 449.816 19.271 459.466 21.7473C463.895 22.8837 467.13 25.0325 469.379 28.0576C471.649 31.1105 474 36.5308 474 46H514ZM514 345.5V46H474V345.5H514ZM390.117 396.587C414.929 414.914 444.616 424.244 470.558 415.998C498.895 406.991 514 380.222 514 345.5H474C474 368.778 465.105 375.759 458.442 377.877C449.384 380.756 433.071 378.586 413.883 364.413L390.117 396.587ZM82.2586 158.316L389.759 396.316L414.241 364.684L106.741 126.684L82.2586 158.316ZM114.5 262V142.5H74.5V262H114.5ZM421.756 251.82L330.756 185.699L307.244 218.058L398.244 284.18L421.756 251.82ZM390 135V268H430V135H390ZM330.844 217.994L421.844 151.116L398.156 118.884L307.156 185.762L330.844 217.994Z" fill="#4CBB85" mask="url(#pathInside_nav)"></path>
              </g>
              <g class="fast-forward">
                <path class="fast-forward-main" d="M84.5 262V282.998L100.802 269.764L136.968 240.406L195.716 288.579L71.444 380.172C50.7538 392.556 36.2291 391.412 27.3053 385.352C17.7569 378.868 10.5 364.12 10.5 341V49.4999V49.3369L10.4947 49.174C9.87879 30.287 19.3305 18.6943 31.3264 13.9147C43.7452 8.96657 59.9596 10.9218 72.9921 22.0925L73.1876 22.2601L73.3915 22.4174L241.892 152.417L248.043 157.164L254.162 152.375L419.662 22.8755L419.763 22.7967L419.862 22.7153C431.95 12.7482 448.846 8.69794 461.952 12.0611C468.307 13.6918 473.62 17.0005 477.405 22.0912C481.199 27.1958 484 34.8278 484 45.9999V345.5C484 371.639 473.552 383.567 461.471 387.407C448.211 391.622 428.592 387.679 408.03 372.522L100.621 134.592L84.5 122.115V142.5V262Z" stroke="#4CBB85" stroke-width="20"></path>
                <path class="fast-forward-triangle" d="M410 125.817V277.285L315.038 201.848L410 120.817Z" fill="none" stroke="#4CBB85" stroke-width="20"></path>
              </g>
            </svg>
            <span class="nav-expand-app-name">Modal</span>
          </div>
          <div class="nav-expand-scroll p-2 py-0">
            <template v-if="$store.state.isPermissionsFetched">
              <template v-for="(group, gi) in navGroups" :key="'eg' + gi">
                <template v-if="group.items.some(i => i.visible && i.key !== 'settings')">
                  <div v-if="gi > 0 && group.label" class="nav-expand-group-heading" :class="group.navClass">
                    {{ group.label }}
                  </div>
                  <template v-for="item in group.items" :key="'ei' + item.key">
                    <router-link v-if="item.visible && item.key !== 'settings'" :to="item.route"
                      class="nav-expand-item"
                      :class="[item.activeClass, item.navClass]"
                      @click="onExpandNavClick(item.route)">
                      <i :class="[item.icon]"></i>
                      <span class="nav-expand-item-label">{{ item.label }}</span>
                      <span v-if="item.key === 'inbox' && inboxBadgeCount > 0"
                        class="nav-expand-badge">
                        {{ inboxBadgeCount }}
                      </span>
                    </router-link>
                  </template>
                </template>
              </template>
            </template>
          </div>
          <div class="nav-expand-bottom-settings">
            <router-link :to="{ name: 'Settings' }"
              class="nav-expand-item"
              @click="onExpandNavClick({ name: 'Settings' })">
              <i class="fa-solid fa-gear"></i>
              <span class="nav-expand-item-label">Settings</span>
            </router-link>
          </div>
        </div>
      </div>

      <!-- End of New Main Navigation -->
    </div>
  </div>
  <!-- Navbar -->
  <nav class="navbar navbar-expand-lg top-0 bg-gradient-dark header position-fixed d-none"
    :class="isBlur ? isBlur : 'shadow-none mb-0 navbar-transparent w-100'">
    <div class="container ps-2 pe-0">
      <router-link class="navbar-brand font-weight-bolder ms-lg-0 ms-3" :class="darkMode ? 'text-black' : 'text-white'"
        to="/"><img src="@/assets/img/modal_logo.png" alt="" width="100" /> </router-link>
      <button class="navbar-toggler text-white" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation" @click="isExpanded = !isExpanded">
        <i class="fa fa-bars"></i>
      </button>
      <div id="navbarSupportedContent" class="pt-3 pb-2 collapse navbar-collapse w-100 py-lg-0">
        <ul class="mx-auto navbar-nav navbar-nav-hover">
          <li class="mx-2 d-flex nav-item dropdown dropdown-hover">
            <router-link :to="{ name: 'Content' }"
              class="cursor-pointer nav-link ps-2 d-flex justify-content-between align-items-center"
              :class="[darkModes]">
              <i class="fa fa-home" aria-hidden="true"></i>
            </router-link>
          </li>
          <li class="mx-2 nav-item dropdown dropdown-hover">
            <router-link :to="{ name: 'Content' }"
              class="cursor-pointer nav-link ps-2 d-flex justify-content-between align-items-center"
              :class="[darkModes]"> Content </router-link>
          </li>
          <!-- <li class="mx-2 nav-item dropdown dropdown-hover">
            <router-link
              :to="{ name: 'CreateArticle' }"
              class="cursor-pointer nav-link ps-2 d-flex justify-content-between align-items-center"
              :class="[darkModes]"
            >
            Create Article
            </router-link>            
          </li> -->
          <!-- <li class="mx-2 nav-item dropdown dropdown-hover">
            <router-link
              :to="{ name: 'Contact' }"
              class="cursor-pointer nav-link ps-2 d-flex justify-content-between align-items-center"
              :class="[darkModes]"
            >
            Contact Us
            </router-link>            
          </li> -->
          <!-- <li class="mx-2 nav-item dropdown dropdown-hover">
            <router-link
              :to="{ name: 'Setup' }"
              class="cursor-pointer nav-link ps-2 d-flex justify-content-between align-items-center"
              :class="[darkModes]"
            >
            Settings
            </router-link>            
          </li> -->
          <li class="mx-2 nav-item dropdown dropdown-hover" v-if="showContactForm">
            <router-link :to="{ name: 'ContactForm' }"
              class="cursor-pointer nav-link ps-2 d-flex justify-content-between align-items-center"
              :class="[darkModes]"> Contact Form </router-link>
          </li>
          <li class="mx-2 nav-item dropdown dropdown-hover" v-if="showContactForm">
            <router-link :to="{ name: 'NewsFlash' }"
              class="cursor-pointer nav-link ps-2 d-flex justify-content-between align-items-center"
              :class="[darkModes]"> NewsFlash </router-link>
          </li>
          <li class="mx-2 nav-item dropdown dropdown-hover">
            <router-link :to="{ name: 'Statistics' }"
              class="cursor-pointer nav-link ps-2 d-flex justify-content-between align-items-center"
              :class="[darkModes]"> Statistics </router-link>
          </li>
          <li class="mx-2 nav-item dropdown dropdown-hover d-lg-none d-block">
            <a href="javascript:void(0)"
              class="cursor-pointer nav-link ps-2 d-flex justify-content-between align-items-centerd"
              @click="logout_user($event)">Logout</a>
          </li>
        </ul>
        <ul class="navbar-nav d-lg-block">
          <li class="nav-item dropdown">
            <a href="#" class="p-lg-0 nav-link"
              :class="`${isNavFixed && !darkMode ? ' opacity-8 text-dark' : 'text-white1'}  ${showMenu ? 'show' : ''}`"
              id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              <div class="d-sm-inline d-block">
                {{ user_support_library_details?.library_domain !== 'undefined' ? user_support_library_details?.library_domain : user_support_library_details?.library_email ? user_support_library_details?.library_email : businessName }}
                &nbsp;<i class="fa fa-caret-down"></i>
                <!-- {{ user.email }} -->
                <!-- {{ user_info.support_lib_id }} -->
              </div>
            </a>
            <ul class="px-2 py-3 dropdown-menu dropdown-menu-end bg-white pt-0" aria-labelledby="dropdownMenuButton1">
              <li class="p-0 border-0 nav-item dropdown dropdown-hover dropdown-subitem list-group-item">
                <router-link :to="{ name: 'Settings' }" class="py-2 dropdown-item ps-3 border-radius-md">Settings
                </router-link>
              </li>
              <li class="p-0 border-0 nav-item dropdown dropdown-hover dropdown-subitem list-group-item">
                <a href="#" class="py-2 dropdown-item ps-3 border-radius-md" @click="showWidget = !showWidget">Preview
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" class="py-2 dropdown-item ps-3 border-radius-md"
                  @click="logout_user($event)">Logout</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div v-if="showWidget" class="position-fixed w-50 widget-preview-wrapper shadow">
    <span
      class="bg-dark cursor-pointer text-white rounded-circle d-flex justify-content-center align-items-center position-absolute close-widget-btn"
      v-on:click="showWidget = !showWidget">
      <i class="fa fa-times fw-bold"></i>
    </span>
    <iframe id="modal_support_frame" :data-app_url="getLocation()"
      :src="'https://app.modalsupport.com/widget/' + support_lib_id" class="widget" frameborder="0"></iframe>
  </div>

  <div v-if="showSop" class="position-fixed w-25 widget-preview-wrapper shadow bg-gray-light sop-preview-pannel">
    <span
      class="bg-dark cursor-pointer text-white rounded-circle d-flex justify-content-center align-items-center position-absolute close-widget-btn sop-btnclose"
      v-on:click="showSop = !showSop">
      <i class="fa fa-times fw-bold"></i>
    </span>
    <PreviewSop />
  </div>
  <div ref="draggable" @click="handleClick" class="admin-help-widget-br" @mousedown="startDrag" :style="draggableStyle">
    <div class="p-0">
      <i :class="iconClass"></i>
    </div>
  </div>
  <div :class="{ 'ahw-preview-pannel': true, open: showAhw }" ref="previewPanel" :style="panelStyle">
    <PreviewAhw :showAhw="showAhw" @closeAhw="showAhw = false" />
  </div>

  <!-- <div :class="{ 'ahw-preview-pannel': true, 'open': showAhw }"> -->
  <!-- <span class="bg-white cursor-pointer rounded-circle d-flex justify-content-center align-items-center position-absolute close-widget-btn ahw-btnclose" v-on:click="showAhw = !showAhw">
        <i class="fa-light fa-xmark-large opacity-3"></i>
      </span> -->
  <!-- <PreviewAhw :showAhw="showAhw" />
  </div> -->
  <!-- <draggable >
    <div class="admin-help-widget-br" @click="showAhw = !showAhw">
      <div class="p-0">
        <i v-if="!showAhw" class="fa-solid fa-circle-question fa-2x"></i>
        <i v-else class="fa-sharp fa-solid fa-circle-chevron-up fa-2x"></i>
      </div>
    </div>
  </draggable> -->
  <!-- End Navbar -->

  <!-- Add this modal structure before the closing template tag -->
  <div class="modal fade" id="activitiesModal" tabindex="-1" aria-labelledby="activitiesModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-full-height modal-left p-0"
      :class="{'modal-full-height-away-mode': isAlertOn}">
      <div class="modal-content h-100">
        <div class="modal-header">
          <h5 class="modal-title" id="activitiesModalLabel">User Activities Feed</h5>
          <div>
            <Popper class="ms-2">
              <button
                class="py-1 px-2 btn text-col-navlink no-shadow text-bold mb-0 border bg-light d-flex justify-content-center align-items-center mx-1 actions-btn">
                <span class="text-xs">{{ feedsFilter.find(el => el.value == selectedFeedsFilter)?.label }}</span>
                <i class="fa-regular text-xs ms-2 fa-chevron-down"></i>
              </button>
              <template #content="{ close }">

                <div class="popover-content inbox-nav-manage-options bg-white shadow mtminus-15" ref="popoverContent">
                  <div class="container-fluid p-0">
                    <ul class="list-unstyled text-sm p-2 mb-0 popli" style="min-width: 160px;">
                      <li class="py-1 p-1 d-flex align-items-center justify-content-between active"
                        v-for="(filter, index) in feedsFilter" :key="index"
                        @click="selectedFeedsFilter = filter.value; feedPage = 1; getActivityFeeds(); close()">
                        <div class="d-flex align-items-center w-100">
                          <a class="text-col-navlink text-xs p-2 py-1" href="javascript:void(0)">{{ filter.label }}</a>
                        </div>
                        <div v-if="selectedFeedsFilter == filter.value"
                          class="d-flex align-items-center justify-content-end w-100">
                          <span><i class="fa-solid fa-check text-success pr-1"></i></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>


              </template>
            </Popper>
          </div>
          <button v-if="totalUnreadActivityFeeds > 0" class="btn btn-light mb-0 btn-sm ms-2 px-2"
            @click="markAllFeedsAsRead()" :disabled="isMarkingAllFeedsAsRead">
            <span v-if="isMarkingAllFeedsAsRead">Loading... <i class="fa fa-circle-o-notch fa-spin"></i></span>
            <span v-else>Mark all activities as read</span>
          </button>
          <button type="button" class="btn-close btn-close-white btn-sm" data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="isActivityFeedsLoading && feedPage == 1">
            <div class="d-flex justify-content-center align-items-center">
              <p class="my-0 me-2">Loading...</p>
              <i class="fa text-dark fa-circle-o-notch fa-spin"></i>
            </div>
          </div>
          <template v-else-if="activityFeeds.length > 0">
            <div v-for="(log, index) in activityFeeds" :id="'log_activty_'+index" :key="index"
              class="card no-shadow border border-light rounded-3 p-0 mb-2 cursor-pointer"
              @click="log?.trigger == 'automation' ? openAutomation(log) : ''; markFeedAsRead(log)"
              :data-bs-dismiss="log?.trigger == 'automation' ? 'modal' : null"
              :class="{ 'active': log?.is_read == false }">
              <div class="card-body d-flex align-items-start gap-3 p-3">
                <div class="flex-shrink-0">
                  <span v-if="log?.trigger == 'automation'"
                    class="avatar rounded-1 d-inline-block text-white fw-bold text-center">
                    <i class="fa-solid fa-bolt text-sm"></i>
                  </span>
                  <span v-else-if="log?.agent?.agent_picture"
                    :style="{ background: `url(${log?.agent?.agent_picture}) no-repeat center center`, backgroundSize: 'cover' }"
                    class="avatar rounded-1 d-inline-block text-white fw-bold text-center">
                  </span>
                  <span v-else class="avatar rounded-1 d-inline-block text-white fw-bold text-center">
                    N/A
                  </span>
                </div>
                <div class="flex-grow-1">
                  <!-- <p class="mb-1 small text-xs me-3">
                    Yellow strip appears for both agents after chat transfer, This would allow us to provide users with a
                    record of their interaction at the end of the Chat - should only appear for
                    <strong class="text-dark">the assigned agent</strong>.
                  </p> -->
                  <p class="mb-1 small text-xs me-3">
                    {{ log?.activity_name }}
                    <template v-if="log?.agent?.agent_name ?? log?.workflow_name">done by <strong
                        class="text-dark">{{ log?.agent?.agent_name ?? log?.workflow_name }}</strong></template>
                  </p>
                  <div class="d-flex justify-content-between align-items-center mt-3">
                    <p class="text-sm text-muted mb-0 text-xs d-flex align-items-center text-uppercase text-gray-500">
                      {{log?.entity_type}} Module
                      <span class="icon-group d-none ms-2">
                        <i v-if="log?.trigger == 'automation'"
                          @click="$event.stopPropagation(); log?.trigger == 'automation' ? openAutomation(log, true) : null; markFeedAsRead(log)"
                          class="fa-regular fa-arrow-up-right-from-square mx-2 d-flex align-items-center readunread-icon "></i>
                        <i v-if="!log?.is_read" data-bs-toggle="tooltip" @mouseleave="$store.commit('removeToolTip');"
                          @click="$event.stopPropagation(); markFeedAsRead(log)" data-bs-placement="right"
                          data-bs-trigger="hover" title="Mark as read"
                          class="fa-solid fa-square-check ms-2  readunread-icon d-flex align-items-center"></i>
                        <i v-else data-bs-toggle="tooltip" @mouseleave="$store.commit('removeToolTip');"
                          @click="$event.stopPropagation(); markFeedAsRead(log, true)" data-bs-placement="right"
                          data-bs-trigger="hover" title="Mark as unread"
                          class="fas fa-times-square ms-2  readunread-icon d-flex align-items-center"></i>
                      </span>
                    </p>
                    <span class="text-muted small text-xs me-2">{{agoTime(log?.created_at)}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center align-items-center mt-3"
              v-if="isActivityFeedsLoading || totalActivityFeeds > activityFeeds.length">
              <button :disabled="isActivityFeedsLoading" type="button" class="btn btn-light mb-0"
                @click="feedPage+=1; getActivityFeeds()">
                <span v-if="isActivityFeedsLoading">Loading... <i class="fa fa-circle-o-notch fa-spin"></i></span>
                <span v-else>Load More</span>
              </button>
            </div>
          </template>
          <div class="d-flex justify-content-center align-items-center mt-3" v-else>
            <p class="text-muted">No activity feeds found</p>
          </div>
        </div>
        <!-- <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import useLogout from '@/composables/useLogout';
import getUserInfo from '@/composables/getUserInfo';
import { useRouter } from 'vue-router';
/* import { ref } from 'vue' */
import downArrWhite from '@/assets/img/down-arrow-white.svg';
import downArrBlack from '@/assets/img/down-arrow-dark.svg';
import { projectFirestore } from '../../../firebase/config';
import moment from 'moment';
import '@/assets/custom_global_chatinbox.css';
import '@/assets/custom_modalchatui.css';
import PreviewSop from '@/views/admin/Sop/PreviewSop';
import PreviewAhw from '@/views/admin/Ahw/PreviewAhw';
import { VueDraggableNext } from 'vue-draggable-next';
import setTooltip from '@/assets/js/tooltip.js';
import Api from '@/api/Api';
import { getBaseUrls } from '@/utils/getBaseUrls';
const {inboxBaseURL} = getBaseUrls();
import axios from 'axios';
import firebase from 'firebase/app';
import { saveModalAdminTheme, useModalAdminTheme } from '@/composables/useModalAdminTheme';
export default {
  name: 'NavbarAdmin',
  components: {
    PreviewSop,
    PreviewAhw,
    draggable: VueDraggableNext,
  },
  setup() {
    const user = ref(localStorage.getItem('user_id'));
    const router = useRouter();
    const { logout, error } = useLogout();
    const support_lib_id = ref(localStorage.getItem('support_Lib_id'));
    // const { user_info_error, user_info, load_user_info } = getUserInfo(user.value.uid);

    // Same objects the Settings → Theme page edits, so both stay in step
    const {
      modalAdminTheme,
      modalAdminThemeFields,
      modalAdminThemeFieldGroups,
      modalAdminThemePresets,
      isModalAdminThemeShortcutActive,
      isModalAdminNavExpandActive,
      isModalAdminThemeDirty,
      isSavingModalAdminTheme,
      resetModalAdminTheme,
    } = useModalAdminTheme();

    return {
      user,
      // user_info,
      support_lib_id,

      logout,
      modalAdminTheme,
      modalAdminThemeFields,
      modalAdminThemeFieldGroups,
      modalAdminThemePresets,
      isModalAdminThemeShortcutActive,
      isModalAdminNavExpandActive,
      isModalAdminThemeDirty,
      isSavingModalAdminTheme,
      resetModalAdminTheme,
    };
  },

  props: {
    btnBackground: {
      type: String,
      default: '',
    },
    isBlur: {
      type: String,
      default: '',
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    isNavFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user_email: localStorage.getItem('user_email'),
      isNavExpanded: false,
      navExpandTimer: null,
      navCollapseTimer: null,
      isColorMenuOpen: false,
      // Sticks the panel open once a field is touched, so the native colour
      // dialog stealing the pointer does not close it mid-pick.
      isColorMenuPinned: false,
      activePresetId: null,
      colorMenuCloseTimer: null,
      downArrWhite,
      downArrBlack,
      showMenu: false,
      isExpanded: false,
      site_url: '',
      showContactForm: true,
      user_support_library_details: null,
      support_lib_error: '',
      businessName: '',
      showWidget: false,
      showSop: false,
      isMenuCollapsed: false,
      awayMode: false,
      darkTheme: false,
      /* drag */
      showAhw: false,
      offsetX: 0,
      offsetY: 0,
      isDragging: false,
      draggableStyle: {
        position: 'absolute',
        cursor: 'pointer',
      },
      panelStyle: {
        position: 'absolute',
        right: 'initial',
        bottom: 'initial',
      },
      allowClick: true,
      isActivityFeedsLoading: false,
      activityFeeds: [],
      totalActivityFeeds: 0,
      limit:10,
      feedPage:1,
      feedsFilter:[
        {label:'Show All', value:null},
        {label:'Show Unread', value:'unread'},
        {label:'Show Read', value:'read'},
      ],
      totalUnreadActivityFeeds:0,
      selectedFeedsFilter:null,
      isMarkingAllFeedsAsRead:false,
      isAlertOn: this.$store.getters.isAlertOn || false,
    };
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick);
  },
  methods: {
    expandNav() {
      if (!this.isModalAdminNavExpandActive) return;
      if (this.isColorMenuOpen) return;
      clearTimeout(this.navCollapseTimer);
      if (this.isNavExpanded) return;
      this.navExpandTimer = setTimeout(() => {
        this.removeToolTip();
        this.isNavExpanded = true;
      }, 120);
    },
    collapseNav() {
      clearTimeout(this.navExpandTimer);
      clearTimeout(this.navCollapseTimer);
      this.isNavExpanded = false;
    },
    onExpandNavClick(route) {
      this.handleRouterLinkClick();
      this.$router.push(route).catch(() => {});
      this.collapseNav();
    },
    applyPreset(preset) {
      this.activePresetId = preset.id;
      Object.keys(preset.colors).forEach(key => {
        this.modalAdminTheme[key] = preset.colors[key];
      });
    },
    scheduleCollapseNav() {
      clearTimeout(this.navExpandTimer);
      if (this.isColorMenuOpen) return;
      this.navCollapseTimer = setTimeout(() => {
        this.isNavExpanded = false;
      }, 200);
    },
    handleNavFocusOut(e) {
      const nav = this.$refs.mainNavEl;
      if (nav && !nav.contains(e.relatedTarget)) {
        this.scheduleCollapseNav();
      }
    },
    openColorMenu() {
      clearTimeout(this.colorMenuCloseTimer);
      this.isColorMenuOpen = true;
    },
    scheduleColorMenuClose() {
      if (this.isColorMenuPinned) return;
      clearTimeout(this.colorMenuCloseTimer);
      this.colorMenuCloseTimer = setTimeout(() => {
        if (!this.isColorMenuPinned) this.isColorMenuOpen = false;
      }, 250);
    },
    closeColorMenu() {
      clearTimeout(this.colorMenuCloseTimer);
      this.isColorMenuPinned = false;
      this.isColorMenuOpen = false;
      this.scheduleCollapseNav();
    },
    handleColorMenuOutsideClick(event) {
      if (!this.isColorMenuOpen) return;
      const wrap = this.$refs.colorMenuEl;
      if (wrap && !wrap.contains(event.target)) this.closeColorMenu();
    },
    async saveQuickAdminTheme() {
      try {
        await saveModalAdminTheme();
        this.$store.state.showToast = {
          title: 'Success',
          description: 'Admin colors saved',
          icon: 'fa fa-check',
          time: moment().valueOf(),
        };
        this.closeColorMenu();
      } catch (err) {
        this.$store.state.showToast = {
          title: 'Error',
          description: 'Error while saving admin colors',
          icon: 'fa fa-exclamation-triangle',
          time: moment().valueOf(),
        };
        this.$store.dispatch('printLog', { text: 'Error while saving admin colors', log: err, type: 'error' });
      }
    },
    async markAllFeedsAsRead() {
      if(this.totalUnreadActivityFeeds == 0) return;
      const totalUnreadActivityFeeds = this.totalUnreadActivityFeeds;
      this.isMarkingAllFeedsAsRead  = true;
      let payload = {
        feedIds: [],
        isRead: true,
        markAll: true,
      }
      this.totalUnreadActivityFeeds = 0;
      this.activityFeeds.forEach(el => {
        el.is_read = true;
      });
      await Api.markFeedAsRead(payload).then(res => {
        // console.log('markAllFeedsAsRead res ', res);
      }).catch(err => {
        this.$store.dispatch('printLog', { text: 'error marking all feeds as read ', log: err, type: 'error' });
        this.totalUnreadActivityFeeds = totalUnreadActivityFeeds;
        this.$store.state.showToast = {
          icon: 'fa fa-exclamation-triangle',
          title: 'Error',
          description: 'An error occurred while marking all feeds as read',
          time: moment().valueOf(),
        }
      }).finally(() => {
        this.isMarkingAllFeedsAsRead = false;
      })
    },
    async markFeedAsRead(log, unread = null) {
      let index = this.activityFeeds.findIndex(el => el.feed_id == log.feed_id);
      if(index === -1) return;
      this.activityFeeds[index].is_read = unread ? false : true;
      if(!unread) {
        this.totalUnreadActivityFeeds--;
      } else {
        this.totalUnreadActivityFeeds++;
      }
      setTimeout(() => {
        setTooltip(this.$store.state.bootstrap);
      }, 1000);
      let payload = {
        feedIds: [log.feed_id],
      }
      if(unread) {
        payload = {
          ...payload,
          isRead: false,
        }
      }

      await Api.markFeedAsRead(payload)
        .then(res => {
          // console.log('markFeedAsRead res ', res);
        })
        .catch(err => {
          this.$store.state.showToast = {
            icon: 'fa fa-exclamation-triangle',
            title: 'Error',
            description: 'An error occurred while marking the feed as read',
            time: moment().valueOf(),
          }
          this.$store.dispatch('printLog', { text: 'error marking feed as read ', log: err, type: 'error' });
          this.activityFeeds[index].is_read = unread ? true : false;
          if(!unread) {
            this.totalUnreadActivityFeeds++;
          } else {
            this.totalUnreadActivityFeeds--;
          }
          setTimeout(() => {
            setTooltip(this.$store.state.bootstrap);
          }, 1000);
        });
    },
    agoTime(date) {
      return moment(date).fromNow();
    },
    openAutomation(log, inNewTab = undefined) {
      if(!log?.workflow_ref) return;
      if(inNewTab) {
        const link = document.createElement('a');
        const routeData = this.$router.resolve({ name: 'ManageAutomation', params: { automation_ref: log.workflow_ref }});

      // Set the href attribute to the resolved route
      link.href = routeData.href;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      // Append the link to the document body
      document.body.appendChild(link);

      // Trigger a click on the link
      link.click();

        // Remove the link from the document
        document.body.removeChild(link);
      } else {
        this.$router.push({ name: 'ManageAutomation', params: { automation_ref: log.workflow_ref }});
      }
    },
    async getActivityFeeds() {
      if(this.feedPage == 1) {
        this.activityFeeds = [];
      }
      this.isActivityFeedsLoading = true;
      let payload = { limit: this.limit, page: this.feedPage }
      if(this.selectedFeedsFilter) {
        payload.isRead = this.selectedFeedsFilter == 'unread' ? false : true;
      }
      Api.getActivityFeeds(payload)
        .then(res => {
          // console.log('getActivityFeeds res ', res?.data?.data);
          this.activityFeeds = [...this.activityFeeds, ...res?.data?.data?.feeds] ?? [];
          this.totalActivityFeeds = res?.data?.data?.pagination?.totalCount ?? 0;
          this.totalUnreadActivityFeeds = res?.data?.data?.unreadCount ?? 0;
          // console.log('this.feedPage ', this.feedPage)
          if(this.feedPage > 1) {
            this.$nextTick(() => {
              // Get the first new element that was loaded in this batch
              const firstNewElementIndex = (this.feedPage - 1) * this.limit;
              const id = 'log_activty_'+firstNewElementIndex;
              const element = document.getElementById(id);
              if(element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            });
          }
        })
        .catch(err => { 
          this.$store.dispatch('printLog', { text: 'error fetching activity feeds ', log: err, type: 'error' });
        })
        .finally(() => {
          this.isActivityFeedsLoading = false;
        });
    },
    handleClick() {
      if (this.allowClick) {
        this.showAhw = !this.showAhw;

        if (this.showAhw) {
          // Position panel relative to draggable once, when opening
          const draggableRect = this.$refs.draggable.getBoundingClientRect();
          this.panelStyle.right = `${window.innerWidth - draggableRect.right}px`;
          this.panelStyle.bottom = `${window.innerHeight - draggableRect.top}px`;
        }
      }
    },

    startDrag(event) {
      this.isDragging = true;
      this.allowClick = true; // reset, assume it’s a click unless moved

      this.offsetX = event.clientX - this.$refs.draggable.getBoundingClientRect().left;
      this.offsetY = event.clientY - this.$refs.draggable.getBoundingClientRect().top;
      this.draggableStyle.cursor = 'grabbing';

      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.endDrag);
      event.preventDefault();
    },

    drag(event) {
      if (this.isDragging) {
        event.preventDefault();
        this.allowClick = false; // as soon as movement detected, block click

        requestAnimationFrame(() => {
          // Update icon position
          this.draggableStyle.left = `${event.clientX - this.offsetX}px`;
          this.draggableStyle.top = `${event.clientY - this.offsetY}px`;

          // Update panel position if open
          if (this.showAhw) {
            const draggableRect = this.$refs.draggable.getBoundingClientRect();
            this.panelStyle.right = `${window.innerWidth - draggableRect.right}px`;
            this.panelStyle.bottom = `${window.innerHeight - draggableRect.top}px`;
          }
        });
      }
    },

    endDrag() {
      this.isDragging = false;
      this.draggableStyle.cursor = 'pointer';

      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.endDrag);

      // Update the position of the preview panel relative to the draggable element
      const draggableRect = this.$refs.draggable.getBoundingClientRect();
      this.panelStyle.right = `${window.innerWidth - draggableRect.right}px`;
      this.panelStyle.bottom = `${window.innerHeight - draggableRect.top}px`;
    },

    changeStatus(event) {
      // console.log('event ', event.target.checked)
      let is_away = event.target.checked ? 1 : 0;
      this.awayMode = event.target.checked;
      this.$store.state.is_away = is_away;
      let payload = {
        action: 'updateAgentInfo',
        agent_action: 'switch_away_mode',
        ref_uid: localStorage.getItem('user_id'),
        away_mode: is_away,
        support_lib_id: localStorage.getItem('support_Lib_id'),
      };
      Api.sendApplicationWebSocket(payload);
    },
    // toggleAdminHelpWidget() {
    //   this.showAhw = !this.showAhw;
    // },
    updateDemoMode(event) {
      const isEnabled = event.target.checked;
      localStorage.setItem('demo_mode', isEnabled.toString());
      this.$store.state.demoMode = isEnabled;

      const fetchMethod = {
        inbox: 'fetchInboxTickets',
        archives: 'fetchArchives',
        tickets: 'fetchTickets',
        drafts: 'fetchDrafts',
        othertickets: 'fetchOtherTickets',
        hlpttickets: 'fetchHlptTickets',
        mentiontickets: 'fetchMentionTickets',
        createdbyyoutickets: 'fetchCreatedByYouTickets',
        unassignedtickets: 'fetchUnassignedTickets',
        reassignedtickets: 'fetchReassignedTickets',
        awaitingreplytickets: 'fetchAwaitingReplyTickets',
        awaitingreplyhlpttickets: 'fetchAwaitingReplyHlptTickets',
        search: 'fetchSearchRecords',
      };
      const method = fetchMethod[this.$route.query.tab];
      if (!method) {
        return;
      }
      if (method === 'fetchSearchRecords') {
        this.$store.state.searchPage = 1;
        this.$store.state.fetchSearchRecords = !this.$store.state.fetchSearchRecords;
        return;
      }
      this.$store.state[method] = true;
    },
    toggleModalTheme() {
      const head = document.head;
      const body = document.body;
      const link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = this.darkTheme ? '/darkmodalui.css' : '';
      const existingLink = document.getElementById('modaldarkui');
      if (existingLink) {
        head.removeChild(existingLink);
        body.classList.remove('dark-theme-body');
      }
      if (this.darkTheme) {
        link.id = 'modaldarkui';
        head.appendChild(link);
        body.classList.add('dark-theme-body');
      }
      localStorage.setItem('darkTheme', JSON.stringify(this.darkTheme));
      window.dispatchEvent(new CustomEvent('darkThemeChanged', { detail: { dark: this.darkTheme } }));
    },
    handleGlobalClick(event) {
      const tooltip = document.querySelector('.tooltip');
      if (tooltip && event.target !== tooltip) {
        tooltip.remove();
      }
    },
    removeToolTip() {
      const tooltip = document.querySelector('.tooltip');
      if (tooltip) {
        tooltip.remove();
      }
    },
    async logout_user(event) {
      if (event instanceof Event && event.isTrusted === false) {
        console.warn("Blocked untrusted trigger");
        return;
      }
      if (this.$store.state.inboxMembers.filter(el => el.ref_uid == this.user).length) {
        this.$swal({
          title: 'Attention!',
          text: `You have ongoing chats, please transfer them to another agent before logging out`,
          icon: 'warning',
          showCancelButton: false,
          cancelButtonText: 'Close',
          confirmButtonText: 'Close',
          customClass: {
            confirmButton: 'btn bg-gradient-success',
            cancelButton: 'btn bg-gradient-danger',
          },
          buttonsStyling: false,
        });
        return;
      }


    if(this.$store.state.support_lib_id !== this.$store.state.init_support_lib_id) {
      const payload = {
        action:"logoutas",
        admin_support_lib_id: this.$store.state.support_lib_id,
      }
      this.$store.state.isLibrarySwitching = true;
      await Api.logoutAs(payload).then((res) => {
        // console.log('success while logging out', res);
      }).catch((err) => {
        console.log('err while logging out', err);
        this.$store.state.showToast = {
          icon: 'fa fa-exclamation-triangle',
          title: 'Error',
          description: 'An error occurred while logging out',
          time: moment().valueOf(),
        }
      }).finally(() => {
        this.$store.state.isLibrarySwitching = false;
      });
    }
      let agent_con_id = localStorage.getItem('agent_connection_agent_con_id');
      let payload = {
        action: 'closeChat',
        ref_uid: localStorage.getItem('user_id'),
        connection_id: agent_con_id,
        ended_by: 'agent',
        force_close: 1,
      };
      await Api.sendApplicationWebSocket(payload);
      if (this.$store.state.socket) {
        this.$store.state.socket.close(1000, 'Logout');
      }
      await this.logout();
    },
    async getSupportLibrary(support_lib_id) {
      try {
        if (support_lib_id) {
          let res = await projectFirestore.collection('SupportLibraries').doc(support_lib_id).get();
          if (!res.exists) {
            throw error('That user support library does not exist');
          }
          if (res.data().settings && res.data().settings.settings.companyName) {
            this.businessName = res.data().settings.settings.companyName;
          }
          this.user_support_library_details = { ...res.data(), id: res.id };
          // console.log('{ ...res.data(), id: res.id }', support_lib_id)
        }
      } catch (err) {
        this.support_lib_error = err.message;
      }
    },
    getLocation() {
      return window.location != window.parent.location ? document.referrer : document.location.href;
    },
    handleRouterLinkClick() {
      const tooltip = document.querySelector('.tooltip');
      if (tooltip) {
        tooltip.remove();
      }
      if (window.location.href.endsWith('/login')) {
        if (tooltip) {
          tooltip.remove();
        }
      }
    },
    toggleMenuCollapse() {
      this.isMenuCollapsed = !this.isMenuCollapsed;
    },
 
    getRandomInitials(index) {
      const names = [
        'GL', 'JD', 'AS', 'RJ', 'MB', 'TW', 'KP', 'LM', 'NS', 'AB', 'CD', 'EF'
      ];
      return names[index % names.length];
    },
  },

  created() {
    const storedDarkTheme = localStorage.getItem('darkTheme');
    if (storedDarkTheme !== null) {
      this.darkTheme = JSON.parse(storedDarkTheme);
    }
    this.toggleModalTheme();
  },

  beforeRouteEnter(to, from, next) {
    const tooltip = document.querySelector('.tooltip');
    if (tooltip) {
      tooltip.remove();
    }
    next();
  },
  watch: {
    '$store.state.is_away': {
      deep: true,
      handler() {
        this.awayMode = this.$store.state.is_away == 0 ? false : true;
      },
    },
    '$store.state.isUserPermissionsLoading': {
      deep: true,
      handler() {
        setTimeout(() => {
          setTooltip(this.$store.state.bootstrap);
        }, 500);
      },
    },
    '$store.getters.isAlertOn': {
      handler() {
        this.isAlertOn = this.$store.getters.isAlertOn || false;
      },
    },
    $route() {
      document.getElementById('navbarSupportedContent').classList.remove('show');
      this.isAlertOn = this.$store.getters.isAlertOn || false;
    },
  },
  async mounted() {
    this.isAlertOn = this.$store.getters.isAlertOn || false;
    // console.log('!!this.$store.state.is_away', !!this.$store.state.is_away)
    this.handleGlobalClick = this.handleGlobalClick.bind(this);
    document.addEventListener('click', this.handleGlobalClick);
    document.addEventListener('mousedown', this.handleColorMenuOutsideClick);

    this.awayMode = this.$store.state.is_away == 0 ? false : true;
    // this.$store.state.show_alert = this.$store.state.is_away == 0 ? false : true;

    // await this.load_user_info(this.user.uid);
    // if (this.user_info && this.user_info.support_lib_id !== undefined) {
    this.support_lib_id = this.$store.state.support_lib_id;
    // } else {
    //   this.logout();
    // }

    // await this.getSupportLibrary(this.support_lib_id);

    this.site_url = 'https://modalsupport.com/' + this.support_lib_id;

    // this.getActivityFeeds();

    // this.$store.state.activityFeedsInterval = setInterval(() => {
    //   this.feedPage = 1;
    //   if(this.$store.state.user_id) {
    //     this.getActivityFeeds();
    //   }
    // }, 1000 * 60 * 5);

    projectFirestore
      .collection('SupportLibraries')
      .doc(this.support_lib_id)
      .get()
      .then(doc => {
        if (doc.exists) {
          if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.favicon) {
            const favicon = document.getElementById('favicon');
            favicon.setAttribute('href', doc.data().publicHelpCenterTheme.favicon);
          } else {
            favicon.setAttribute('href', '/favicon.ico');
          }

          if (doc.data().settings && doc.data().settings.settings.companyName) {
            this.businessName = doc.data().settings.settings.companyName;
          }
          this.user_support_library_details = { ...doc.data(), id: doc.id };
        }
      });
  },
  beforeUnmount() {
    clearTimeout(this.navExpandTimer);
    clearTimeout(this.navCollapseTimer);
    clearTimeout(this.colorMenuCloseTimer);
    document.removeEventListener('mousedown', this.handleColorMenuOutsideClick);
  },
  computed: {
    init_support_lib_id() {
      return localStorage.getItem('init_support_lib_id');
    },
    default_support_lib_id() {
      return process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID;
    },
    timestampVal() {
      return moment().valueOf();
    },
    user_type() {
      return this.$store.state.agent_role;
    },
    iconClass() {
      return this.showAhw ? 'fa-sharp fa-solid fa-circle-chevron-up fa-2x' : 'fa-solid fa-circle-question fa-2x';
    },
    darkModes() {
      return {
        'text-dark': this.darkMode,
      };
    },
    isShowActive() {
      let activeRoutes = ['YourReports', 'AllReports', 'Topics', 'Suggestions', 'SupportOverview', 'Calls', 'Conversations', 'ConversationTags', 'CustomerSatisfaction', 'Effectiveness', 'Responsiveness', 'TeamInboxPerformance', 'TeammatePerformance', 'TicketsReport', 'ConversationalSupport', 'ModalAIAgent', 'AutomationReport', 'KnowledgebaseReport', 'CoursesReport', 'SOPsReport', 'NewsFlashReport'];
      return activeRoutes.includes(this.$route.name);
    },
    inboxBadgeCount() {
      const p = this.$store.state?.userPermissions;
      if (!p?.canTakeChats) return 0;
      return this.$store?.state?.queueMembers?.length || 0;
    },
    navGroups() {
      const p = this.$store.state?.userPermissions || {};
      const ut = this.user_type;
      // Same gate Settings uses for the Modal AI and Modal Logs sections
      const isParentLib = this.$store.state?.support_lib_id == this.default_support_lib_id;
      return [
        {
          label: 'COMMUNICATION',
          items: [
            {
              key: 'inbox',
              label: 'Inbox',
              tooltip: 'Inbox',
              icon: 'fa-solid fa-message-lines',
              route: { name: 'ChatInboxClone', query: { tab: 'inbox' } },
              visible: !!(p.canTakeChats || p.canSuperviseChats || p.canViewChatArchives || p.canViewExistingTickets),
              activeClass: {},
              id: null,
            },
          ],
        },
        {
          label: 'KNOWLEDGE BASE',
          items: [
            {
              key: 'articles',
              label: 'Articles',
              tooltip: 'Articles',
              icon: 'fa-solid fa-book-open-reader',
              route: { name: 'Content' },
              visible: !!p.canCreateAndUpdateHelpCenterArticles,
              activeClass: {},
              id: null,
            },
            {
              key: 'sops',
              label: 'SOPs',
              tooltip: 'SOPs',
              icon: 'fa-solid fa-tasks',
              route: { name: 'Sop' },
              visible: !!p.canCreateAndUpdateSopArticles,
              activeClass: {},
              id: 'sopNavLink',
            },
            {
              key: 'courses',
              label: 'Courses',
              tooltip: 'Courses',
              icon: 'fa-solid fa-book-copy',
              route: { name: 'Courses' },
              visible: !!p.canCreateAndUpdateCoursesArticles,
              activeClass: {},
              id: null,
            },
          ],
        },
        {
          label: 'BUILD & CUSTOMIZE',
          items: [
            {
              key: 'flowBuilder',
              label: 'Flow Builder',
              tooltip: 'Flow Builder',
              icon: 'fa-solid fa-shoe-prints',
              route: { name: 'Flowbuilder' },
              visible: !!p.canViewForms,
              activeClass: {},
              id: 'flowbuilder-hide-test',
            },
            {
              key: 'formBuilder',
              label: 'Form Builder',
              tooltip: 'Form Builder',
              icon: 'fa-solid fa-list-dropdown',
              route: { name: 'Formbuilder' },
              visible: !!p.canViewForms,
              activeClass: {},
              id: 'formbuilder-hide',
            },
            {
              key: 'contactForm',
              label: 'Contact Form',
              tooltip: 'Contact Form',
              icon: 'fa-solid fa-envelope-open-text',
              route: { name: 'ContactForm' },
              visible: !!(ut && ut !== 'agent' && ut !== 'writer' && ut !== 'editor' && this.showContactForm),
              activeClass: {},
              id: null,
            },
          ],
        },
        {
          label: 'AI & AUTOMATION',
          items: [
            {
              key: 'automation',
              label: 'Automations',
              tooltip: 'Automation',
              icon: 'fa-solid fa-bolt',
              route: { name: 'Automation' },
              visible: !!(p.canCreateAndEditAnAutomation || p.canDeleteAnAutomation || p.canViewAutomations),
              activeClass: {},
              id: null,
            },
            {
              key: 'integrations',
              label: 'Integrations',
              tooltip: 'Integrations',
              icon: 'fa-solid fa-square-share-nodes',
              route: { name: 'Integrations' },
              visible: !!p.canViewIntegrations,
              activeClass: {},
              id: null,
            },
            {
              key: 'aiAgents',
              label: 'AI Agents',
              tooltip: 'AI Agents',
              icon: 'fa-solid fa-robot',
              route: { name: 'ModalAgents' },
              visible: !!(isParentLib || this.$store.state.support_lib_id == process.env.VUE_APP_DEMO_ACCOUNT_SUPPORT_LIB_ID),
              // Stay lit while an agent is being created or edited
              activeClass: { active: ['ModalAgents', 'ModalAgentsSetup', 'ModalAgentsManagedSetup', 'ModalAgentSkills', 'ModalAgentSkillSetup', 'ModalAgentCorePrompt', 'ModalAgentConnectionLimits'].includes(this.$route.name) },
              id: null,
            },
          ],
        },
        {
          label: 'INSIGHTS',
          items: [
            {
              key: 'reports',
              label: 'Reports',
              tooltip: 'Reports',
              icon: 'fa-solid fa-chart-simple',
              route: { name: 'SupportOverview' },
              visible: !!p.canViewReports,
              activeClass: { active: this.isShowActive },
              id: null,
            },
            {
              key: 'newsFlash',
              label: 'NewsFlash',
              tooltip: 'News Flash',
              icon: 'fa-solid fa-newspaper',
              route: { name: 'NewsFlash' },
              visible: !!p.canCreateAndUpdateNewsArticles,
              activeClass: {},
              id: null,
            },
            // {
            //   key: 'aiLogs',
            //   label: 'AI Activities Logs',
            //   tooltip: 'AI Activities Logs',
            //   icon: 'fa-solid fa-clock-rotate-left',
            //   route: { name: 'AILogs' },
            //   visible: !!isParentLib,
            //   activeClass: {},
            //   id: null,
            // },
          ],
        },
        {
          label: 'PRODUCTIVITY',
          navClass: 'vault-o-workspace',
          items: [
            {
              key: 'vault-o',
              label: 'Vault-O',
              tooltip: 'Vault-O',
              icon: 'nav-icon-archive',
              route: { name: 'Vault-O' },
              visible: true,
              activeClass: {},
              navClass: 'vault-o-workspace',
              id: null,
            },
          ],
        },
        {
          label: 'PRODUCTIVITY',
          items: [
            {
              key: 'vault',
              label: 'Vault',
              tooltip: 'Vault',
              icon: 'nav-svg-icon nav-svg-icon-vault',
              route: { name: 'Vault' },
              visible: true,
              activeClass: {},
              id: null,
            },
          ],
        },
      ];
    },
  },
};
</script>
<style scoped>
/* SVG nav icons drawn as a mask, so they take the nav's text colour like the Font Awesome ones. */
.nav-svg-icon {
  display: inline-block;
  width: 1.15em;
  height: 1.15em;
  vertical-align: -0.2em;
  background-color: currentColor;
  -webkit-mask: center / contain no-repeat;
  mask: center / contain no-repeat;
}
.nav-svg-icon-vault {
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 640'%3E%3Cpath d='M276.4 169.8L296 178L296 522.4C248.4 505 198 496 147.2 496L112 496L112 144L147.2 144C191.6 144 235.5 152.8 276.4 169.8zM492.8 496C442 496 391.6 505 344 522.4L344 178L363.6 169.8C404.5 152.8 448.4 144 492.8 144L528 144L528 496L492.8 496zM320 136L294.9 125.5C248.1 106 197.9 96 147.2 96L112 96C85.5 96 64 117.5 64 144L64 496C64 522.5 85.5 544 112 544L147.2 544C197.9 544 248.1 554 294.9 573.5L307.7 578.8C315.6 582.1 324.4 582.1 332.3 578.8L345.1 573.5C391.9 554 442.1 544 492.8 544L528 544C554.5 544 576 522.5 576 496L576 144C576 117.5 554.5 96 528 96L492.8 96C442.1 96 391.9 106 345.1 125.5L320 136zM168 192C154.7 192 144 202.7 144 216C144 229.3 154.7 240 168 240L172.2 240C192 240 211.5 244.6 229.2 253.5C241.1 259.4 255.5 254.6 261.4 242.8C267.3 231 262.5 216.5 250.7 210.6C226.3 198.4 199.4 192.1 172.2 192.1L168 192.1zM467.8 192C440.5 192 413.7 198.3 389.3 210.5C377.4 216.4 372.6 230.8 378.6 242.7C384.6 254.6 398.9 259.4 410.8 253.4C428.5 244.5 448 239.9 467.8 239.9L472 239.9C485.3 239.9 496 229.2 496 215.9C496 202.6 485.3 191.9 472 191.9L467.8 191.9zM168 288C154.7 288 144 298.7 144 312C144 325.3 154.7 336 168 336L172.2 336C192 336 211.5 340.6 229.2 349.5C241.1 355.4 255.5 350.6 261.4 338.8C267.3 327 262.5 312.5 250.7 306.6C226.3 294.4 199.4 288.1 172.2 288.1L168 288.1zM467.8 288C440.5 288 413.7 294.3 389.3 306.5C377.4 312.4 372.6 326.8 378.6 338.7C384.6 350.6 398.9 355.4 410.8 349.4C428.5 340.5 448 335.9 467.8 335.9L472 335.9C485.3 335.9 496 325.2 496 311.9C496 298.6 485.3 287.9 472 287.9L467.8 287.9zM168 384C154.7 384 144 394.7 144 408C144 421.3 154.7 432 168 432L172.2 432C192 432 211.5 436.6 229.2 445.5C241.1 451.4 255.5 446.6 261.4 434.8C267.3 423 262.5 408.5 250.7 402.6C226.3 390.4 199.4 384.1 172.2 384.1L168 384.1zM467.8 384C440.5 384 413.7 390.3 389.3 402.5C377.4 408.4 372.6 422.8 378.6 434.7C384.6 446.6 398.9 451.4 410.8 445.4C428.5 436.5 448 431.9 467.8 431.9L472 431.9C485.3 431.9 496 421.2 496 407.9C496 394.6 485.3 383.9 472 383.9L467.8 383.9z'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 640'%3E%3Cpath d='M276.4 169.8L296 178L296 522.4C248.4 505 198 496 147.2 496L112 496L112 144L147.2 144C191.6 144 235.5 152.8 276.4 169.8zM492.8 496C442 496 391.6 505 344 522.4L344 178L363.6 169.8C404.5 152.8 448.4 144 492.8 144L528 144L528 496L492.8 496zM320 136L294.9 125.5C248.1 106 197.9 96 147.2 96L112 96C85.5 96 64 117.5 64 144L64 496C64 522.5 85.5 544 112 544L147.2 544C197.9 544 248.1 554 294.9 573.5L307.7 578.8C315.6 582.1 324.4 582.1 332.3 578.8L345.1 573.5C391.9 554 442.1 544 492.8 544L528 544C554.5 544 576 522.5 576 496L576 144C576 117.5 554.5 96 528 96L492.8 96C442.1 96 391.9 106 345.1 125.5L320 136zM168 192C154.7 192 144 202.7 144 216C144 229.3 154.7 240 168 240L172.2 240C192 240 211.5 244.6 229.2 253.5C241.1 259.4 255.5 254.6 261.4 242.8C267.3 231 262.5 216.5 250.7 210.6C226.3 198.4 199.4 192.1 172.2 192.1L168 192.1zM467.8 192C440.5 192 413.7 198.3 389.3 210.5C377.4 216.4 372.6 230.8 378.6 242.7C384.6 254.6 398.9 259.4 410.8 253.4C428.5 244.5 448 239.9 467.8 239.9L472 239.9C485.3 239.9 496 229.2 496 215.9C496 202.6 485.3 191.9 472 191.9L467.8 191.9zM168 288C154.7 288 144 298.7 144 312C144 325.3 154.7 336 168 336L172.2 336C192 336 211.5 340.6 229.2 349.5C241.1 355.4 255.5 350.6 261.4 338.8C267.3 327 262.5 312.5 250.7 306.6C226.3 294.4 199.4 288.1 172.2 288.1L168 288.1zM467.8 288C440.5 288 413.7 294.3 389.3 306.5C377.4 312.4 372.6 326.8 378.6 338.7C384.6 350.6 398.9 355.4 410.8 349.4C428.5 340.5 448 335.9 467.8 335.9L472 335.9C485.3 335.9 496 325.2 496 311.9C496 298.6 485.3 287.9 472 287.9L467.8 287.9zM168 384C154.7 384 144 394.7 144 408C144 421.3 154.7 432 168 432L172.2 432C192 432 211.5 436.6 229.2 445.5C241.1 451.4 255.5 446.6 261.4 434.8C267.3 423 262.5 408.5 250.7 402.6C226.3 390.4 199.4 384.1 172.2 384.1L168 384.1zM467.8 384C440.5 384 413.7 390.3 389.3 402.5C377.4 408.4 372.6 422.8 378.6 434.7C384.6 446.6 398.9 451.4 410.8 445.4C428.5 436.5 448 431.9 467.8 431.9L472 431.9C485.3 431.9 496 421.2 496 407.9C496 394.6 485.3 383.9 472 383.9L467.8 383.9z'/%3E%3C/svg%3E");
}
.header {
  z-index: 999;
}


.widget-preview-wrapper {
  top: 0;
  z-index: 9999;
  right: 0;
  width: 100%;
  height: 100%;
}

.widget {
  width: 100%;
  height: 100%;
}

.close-widget-btn {
  right: 25px;
  top: 25px;
  width: 35px !important;
  height: 35px !important;
  z-index: 999;
}

.sop-btnclose {
  right: 5px !important;
  top: 10px !important;
  width: 25px !important;
  height: 25px !important;
  z-index: 999;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.01); /* Semi-transparent black */
}
.modal-chat-inbox .nav-icons a i.fa-clipboard-list-check.fa-2x {
  font-size: 18px;
}
.profile-icon {
  padding: 5px 10px 5px 10px !important;
}
.plus.unread-conversations {
  /* hundred-plus */
  letter-spacing: -0.07rem;
  max-width: 14px;
  max-height: 14px;
  width: 14px;
  height: 14px;
  right: 6px;
}

/* Lucide archive. The Font Awesome 6 kit does not include this glyph,
   so it is drawn with a mask and still follows the rail icon color. */
.nav-icon-archive {
  display: inline-block;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  background-color: currentColor;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cg fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect width='20' height='5' x='2' y='3' rx='1'/%3E%3Cpath d='M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8'/%3E%3Cpath d='M10 12h4'/%3E%3C/g%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cg fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect width='20' height='5' x='2' y='3' rx='1'/%3E%3Cpath d='M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8'/%3E%3Cpath d='M10 12h4'/%3E%3C/g%3E%3C/svg%3E");
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}

.nav-expand-item .nav-icon-archive {
  width: 22px;
  flex-basis: 22px;
}

.plus.unread-conversations.userfeednotifications {
  letter-spacing: -0.04rem;
  max-width: 14px;
  max-height: 14px;
  width: 14px;
  height: 14px;
  right: 6px;
  font-size: 10px !important;
  background-color: #f8dc77;
  color: black;
  padding: 8px;
  top: 0px;
  /* border: 2px solid #000; */
}

.plus.unread-conversations.hundred-plus:after {
  content: '+';
  position: absolute;
  top: -10px;
  right: -3px;
  color: #000;
}
.profile-image-container {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.admin-help-widget-br {
  width: 50px;
  height: 50px;
}
.admin-help-widget-br i::before {
  background-color: white;
  border-radius: 50%;
}

#activitiesModal {
  z-index: 999999!important;
}
#activitiesModal .modal-dialog.modal-left {
  margin: 0;
  position: fixed;
  left: 40px;
  top: 0;
  height: 100vh;
  width: 565px;
  max-width: 565px;
  transform: none !important;
}

#activitiesModal .modal-full-height {
  height: 100vh;
}
#activitiesModal .modal-full-height-away-mode {
  top: 40px!important;
  height: calc(100vh - 40px)!important;
}

#activitiesModal .modal-content {
  border-radius: 0;
  border: none;
}

#activitiesModal .modal.fade .modal-dialog.modal-left {
  transform: translateX(-100%);
}

#activitiesModal .modal.show .modal-dialog.modal-left {
  transform: translateX(0);
}
#activitiesModal .card.active,
#activitiesModal .card:hover {
 border: 1px solid var(--mi-chat-primary-color) !important;
}

#activitiesModal .card .avatar {
  background: #c1c1c1;
  width: 30px;
  height: 30px;
  line-height: 30px;
}
#activitiesModal .card:hover .avatar {
  /* background: var(--mi-chat-primary-color) !important; */
}
#activitiesModal .card:hover .icon-group.d-none {
  display: flex !important;
}
#activitiesModal .card .text-gray-500 {
    color: #999 !important;
    }
#activitiesModal .modal-title {
  color: #444 !important;
  font-size: 18px !important;
}

/* Quick colour picker in the icon rail */
.admin-theme-quick {
  --popper-theme-background-color: transparent;
  --popper-theme-background-color-hover: transparent;
  --popper-theme-text-color: inherit;
  --popper-theme-border-width: 0;
  --popper-theme-border-radius: 8px;
  --popper-theme-padding: 0;
  --popper-theme-box-shadow: none;
}

.admin-theme-quick-btn {
  width: 100%;
  color: inherit;
  cursor: pointer;
}

.admin-theme-quick-panel {
  width: 208px;
  text-align: left;
  cursor: default;
  /* Matches the profile popover card */
  border: 1px solid rgba(0, 0, 0, 0.01);
  border-radius: 8px;
  box-shadow: 0 15px 20px rgba(32, 40, 77, 0.15), 0 15px 80px rgba(32, 40, 77, 0.1);
}

.admin-theme-quick-fields {
  max-height: 200px;
  overflow-y: auto;
}

/* Label takes the slack so every swatch lines up on the same right edge */
.admin-theme-quick-label {
  flex: 1 1 auto;
  min-width: 0;
}

.admin-theme-quick-input {
  width: 100px;
  flex: 0 0 auto;
}

.admin-theme-quick-input input[type='color'] {
  width: 16px;
  min-width: 16px;
  height: 16px;
  background-color: transparent;
  cursor: pointer;
}

.admin-theme-quick-input .form-control {
  height: 22px;
  min-height: 22px;
  line-height: 22px;
}

/* Heading above a run of related inputs, e.g. "Customize Expanded Menu" */
.admin-theme-quick-group {
  margin: 2px 0 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8a8a8a;
}

/* ---- Preset theme buttons ---- */
.admin-theme-presets {
  margin-bottom: 4px;
}

.admin-theme-presets-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
}

.admin-theme-preset-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
  font-size: 0.7rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.admin-theme-preset-btn:hover {
  border-color: rgba(0, 0, 0, 0.25);
  background: #f9f9f9;
}
.admin-theme-preset-btn--active {
  border-color: rgba(0, 0, 0, 0.35) !important;
  background: #f3f3f3 !important;
}

.admin-theme-preset-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
i.nav-svg-icon.nav-svg-icon-vault.text-sm {
    font-size: 15px !important;
}
</style>
<style>
/* The icon list is the scrollport. Firefox (Windows) will not draw a bar
   narrower than `thin` (~8px). The negative margin slides that bar past the
   rail's right edge; the parent clips it, leaving about a 2px sliver.
   Chrome supports the webkit bar, so the block below cancels the shift and
   hands the width back to the 2px rule. */
.modal-chat-inbox .app-main-nav .nav-scroll-area > .nav-icons-scroll {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: -6px;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(114, 102, 89, 0.22) transparent !important;
}
@supports selector(::-webkit-scrollbar) {
  .modal-chat-inbox .app-main-nav .nav-scroll-area > .nav-icons-scroll {
    margin-right: 0;
    scrollbar-width: auto !important;
    scrollbar-color: auto !important;
  }
}
.modal-chat-inbox .app-main-nav .nav-scroll-area > .nav-icons-scroll::-webkit-scrollbar {
  width: 2px !important;
  height: 2px !important;
}
.modal-chat-inbox .app-main-nav .nav-scroll-area > .nav-icons-scroll::-webkit-scrollbar-track {
  background: transparent !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.modal-chat-inbox .app-main-nav .nav-scroll-area > .nav-icons-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(114, 102, 89, 0.22) !important;
  border: 0 !important;
  border-radius: 2px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
